import { OccurrenceService } from './../../../../../shared/src/lib/service/occurrence.service';
/**
 * composant pour l'affichage d'une occurrence d'un invoice.
 */

import { Component, OnInit, Input } from '@angular/core';
import { FormationService } from '../../../../../shared/src/lib/service/formation.service';
import moment from 'moment';
import { Lilate } from '../../../../../shared/src/lib/model/lilate.model';
import { LilateService } from '../../../../../shared/src/lib/service/lilate.service';
import { SessionService } from '../../../../../shared/src/lib/service/session.service';
import { ExaminationSessionService } from '../../../../../shared/src/lib/service/examination-session.service';
import { ExaminationSession } from '../../../../../shared/src/lib/model/examination-session.model';
@Component({
  selector: 'app-class-details',
  templateUrl: './class-details.component.html',
  styleUrls: ['./class-details.component.scss']
})
export class ClassDetailsComponent implements OnInit {
  @Input() occurrence;
  @Input() session: ExaminationSession;
  @Input() type: String;
  student;
  formationCall;
  showSession = false;
  constructor(
    private formationService: FormationService,
    private examinationSessionService: ExaminationSessionService,
    private sessionService: SessionService,
  ) { }

  ngOnInit() {
    if (this.type === 'lilate') {
      this.student = this.session.lilate.student;
      this.setDuration(this.session);  
    } else {
      this.student = this.occurrence.student;
      this.setDuration(this.occurrence);  
    }
    this.showSession = true;
  }

  setDuration(_occ) {
    const ms = moment(moment(_occ.end), 'HH:mm').diff(moment(moment(_occ.start), 'HH:mm'));
    const _duration = moment.utc(moment.duration(ms).asMilliseconds())
    if (_duration.hour() < 1) {
      _occ.duration = _duration.minute() + 'm';
    } else {
      _occ.duration = _duration.hour() + 'h' + (_duration.minute() === 0 ? '' : _duration.minute());
    }
  }

  getStatusSessionStatusLabel(sessionStatus) {
    return this.examinationSessionService.getExaminationSessionsStatus().find(status => status.value === sessionStatus).label
  }

  getStatusOccurrenceLabel(code) {
    return this.sessionService.getSessionsStatus().find(status => status.code === code).label
  }

}
